/* eslint-disable class-methods-use-this */

/**
 * A class to set Anvato player user preferences in local storage.
 */
export default class UserPreferences {
  /**
   * Mute preference localStorage session key.
   *
   * @type {string}
   */
  mutePrefKey = 'nxsAnvMutePref';

  /**
   * Mute event name.
   *
   * @type {string}
   */
  eventNameMute = 'USER_MUTE';

  /**
   * Unmute event name.
   *
   * @type {string}
   */
  eventNameUnMute = 'USER_UNMUTE';

  /**
   * Constructor
   *
   * @param {Object} anvInstance an AnvatoPlayer instance.
   */
  constructor(anvInstance) {
    this.anvInstance = anvInstance;
  }

  /**
   * Set a user preference in local storage.
   *
   * @param {String} key
   * @param {String} value
   */
  setUserPreference(key, value) {
    localStorage.setItem(key, value);
  }

  /**
   * Get a user preference in local storage.
   *
   * @param {String} key
   * @return {String} value of key
   */
  getUserPreference(key) {
    return localStorage.getItem(key);
  }

  /**
   * Set mute/unmute based on user preference.
   */
  setMutePreference() {
    const mutePref = this.getUserPreference(this.mutePrefKey);

    switch (mutePref) {
      case this.eventNameMute:
        this.anvInstance.mute();
        break;

      case this.eventNameUnMute:
        this.anvInstance.unmute();
        break;

      default:
        this.anvInstance.mute();
        break;
    }
  }
}
